module.exports = __webpack_public_path__ + "static/media/09_blanco.f4b01ad6.svg";